var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-brand d-flex flex-column align-items-center flex-column-auto py-4 py-lg-8"},[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('a',{staticClass:"text-center mb-10",attrs:{"href":"#"}},[_c('img',{staticClass:"max-h-20px",attrs:{"src":"media/logos/bt.png","alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }